import useHttp from './httpService';

const useCategories = () => {
	const { getAll100 } = useHttp();
	const getAllCategories = (language = 'ua') => getAll100('category', 
	'GET',
	null,
	{'Accept-Language': `${language}`, 
	'X-Workspace': 'uaep',
	'Access-Control-Allow-Origin': '*'})
	return getAllCategories;
};

export default useCategories;
